<template>
  <div>
    <div class="sunshine-port">
      <Crumbs :info="info" :title="navList[0]" />
      <div class="port-container">
        <div class="port-nav">
          <MenuComBToC :navList="navList" />
        </div>
        <div class="port-content">
          <!-- 书写内容区域 -->
          <div class="content-nav">
            <ul class="nav-title">
              <li
                v-for="(item, index) in tabList"
                :key="index"
                :class="[
                  item.isFlex ? 'full-title' : '',
                  idx === index ? 'active-li' : ''
                ]"
                @click="idx = index"
              >
                {{ item.label }}
              </li>
            </ul>
            <div class="content-text">
              <div v-if="idx === 0" class="business-text">
                <p>2014年2月10日，海关总署增列海关监管代码“9610”，全称“跨境贸易电子商务”，简称“电子商务”，适用于境内个人或电子商务企业通过电子商务交易平台实现交易，并采用“清单核放、汇总申报”模式办理通关手续的电子商务零售进出口商品，以“9610”海关监管方式开展电子商务零售进出口业务的电子商务企业、物流企业、监管场所经营企业应当按照规定向海关备案，并通过电子商务通关服务平台实时向电子商务通关管理平台传送交易、支付、仓储和物流等数据。</p>
                <p>根据2018年海关总署第194号公告，跨境电子商务综合试验区内符合条件的跨境电子商务零售出口商品，可采取”清单核放，汇总统计“的方式办理报关手续。</p>
                <img src="../../../assets/images/BTOC/jpg.png" alt="">
              </div>
              <div v-if="idx === 1" class="advantage-text">
                <p>1.阳光的通关方式。正规、合法的监管模式，促进跨境电商零售进出口阳光化发展。</p>
                <p>2.便利的通关流程。“清单核放”保证通关效率，解决跨境出口订单数量少、批次多的问题。</p>
                <p>3.经济的通关成本。“汇总申报”定期汇总报关，节约通关成本，解决跨境电商出口逐个包裹报关成本高的问题。</p>
                <p>4.便捷的退、免税操作。跨境电商申报信息可作为税务附报内容，支持跨境电商出口企业无忧退、免税。</p>
                <p>5.配套完整的资金结算。配套外汇资金收结汇服务，依托海关结关数据，快捷回流货款，缓解跨境电商出口企业资金压力。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuComBToC from "./common/menuComBToC";
import Crumbs from "../SunShine/common/Crumbs.vue";
import { navList, tabList } from "../../../model/bToC";
export default {
  components: {
    MenuComBToC,
    Crumbs
  },
  data() {
    return {
      info: {},
      navList,
      tabList,
      idx: 0
    };
  },
  created() {
    const path = this.$route.fullPath;
    const index = navList.findIndex(item => item.path === path);
    if (index !== -1) {
      this.info = navList[index];
    }
  }
};
</script>

<style scoped>
.nav-title {
  display: flex;
  height: 50px;
  background: #eef0f4;
  border-radius: 8px 8px 0px 0px;
  line-height: 50px;
  width: 100%;
  border-bottom: 3px solid #D3D3D3;
  margin-bottom: 30px;
}
.nav-title .full-title {
  flex: 1;
}
.nav-title li {
  font-size: 22px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  padding-left: 25px;
  padding-right: 10px;
  cursor: pointer;
}
.nav-title .active-li {
  border-radius: 8px 8px 0px 0px;
  background: #F47310;
  color: #fff;
}
.content-nav {
  width: 816px;
  margin: 0 auto;
}
.port-nav {
  margin-right: 21px;
}
.port-container {
  width: 1200px;
  height: 991px;
  margin: 0 auto;
  display: flex;
  padding: 34px 30px;
  border: 1px solid #d3d3d3;
  margin-top: 30px;
  margin-bottom: 186px;
}
.port-content {
  flex: 1;
}
.nav-title li:hover {
    border-radius: 8px 8px 0px 0px;
    background: #F47310;
    color: #fff;
}
.port-content h2 {
  height: 38px;
  font-size: 30px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #34373b;
  line-height: 38px;
  display: block;
  margin-bottom: 34px;
}
.port-content p {
  text-indent: 2em;
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #000000;
  line-height: 34px;
  margin-bottom: 34px;
}
.advantage-text p{
  text-indent: 0;
  margin: 0;
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #000000;
  line-height: 38px;
}

</style>



// WEBPACK FOOTER //
// src/components/children/BToC/Introduce.vue